'use strict';
ui.loadTemplateFile('npcchat.html');

class NpcChatDialog extends Dialog {
  _element: any;
  _titleBar: any;
  _message: any;
  _options: any;
  _conversation: any;

  constructor(conversation: any) {
    super('npcchat.html');

    this._message = ui.label(this, '.label.message');
    this._options = ui.list(this, '.list.options');

    this._conversation = conversation;
    this._conversation.on('changed', this._update.bind(this));
    this._conversation.on('closed', this.close.bind(this));
    this._update();
  }

  _selectOption(index: any) {
    if (index === 0) {
      this._conversation.end();
    } else {
      this._conversation.pickOption(index);
    }
  }

  _update() {
    const options = this._conversation.options;
    const message = this._conversation.message;
    let index = 1;

    this._message.text(message);
    this._options.clear();

    for (let id in options) {
      if (options.hasOwnProperty(id)) {
        let item = ui.listitem();
        item.text(index + '. ' + options[id]);
        this._options.append(item).on('clicked', this._selectOption.bind(this, parseInt(id)));
        index++;
      }
    }

    // Original CON files include their own localized CLOSE entry alongside
    // the other player choices. Only synthesize a close action when a final
    // message genuinely has no choices of its own.
    if (index === 1) {
      const item = ui.listitem();
      item.text('0. Close');
      this._options.append(item).on('clicked', this._selectOption.bind(this, 0));
    }
  }
}

ui.NpcChatDialog = NpcChatDialog;

ui.npcChatDialog = (conversation: any) => {
  return new ui.NpcChatDialog(conversation);
};
